import React from "react";

// Inline icons used across the composer (toolbar, attach buttons, cards).
// Colour and size come from the parent via `currentColor` and the `svg`
// rules in composer.scss, so these stay prop-less and presentation-free.

// Bold and italic are text glyphs, not paths — the weight and serif styling
// live in composer.scss (`&__fmt-b` / `&__fmt-i`).
export const BoldIcon = () => (
  <span className="community-composer__fmt-b" aria-hidden="true">
    B
  </span>
);

export const ItalicIcon = () => (
  <span className="community-composer__fmt-i" aria-hidden="true">
    I
  </span>
);

export const BulletListIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <line x1="9" y1="6" x2="20" y2="6" />
    <line x1="9" y1="12" x2="20" y2="12" />
    <line x1="9" y1="18" x2="20" y2="18" />
    <circle cx="4.5" cy="6" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="4.5" cy="12" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="4.5" cy="18" r="1.4" fill="currentColor" stroke="none" />
  </svg>
);

export const NumberedListIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <line x1="10" y1="6" x2="20" y2="6" />
    <line x1="10" y1="12" x2="20" y2="12" />
    <line x1="10" y1="18" x2="20" y2="18" />
    <text x="2.5" y="8.5" fontSize="7.5" fontWeight="800" fill="currentColor" stroke="none" fontFamily="inherit">1</text>
    <text x="2.5" y="14.5" fontSize="7.5" fontWeight="800" fill="currentColor" stroke="none" fontFamily="inherit">2</text>
    <text x="2.5" y="20.5" fontSize="7.5" fontWeight="800" fill="currentColor" stroke="none" fontFamily="inherit">3</text>
  </svg>
);

// Shared by the Photo attach button and the image attachment chip.
export const PhotoIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <path d="m21 15-5-5L5 21" />
  </svg>
);

export const LinkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1.5 1.5" />
    <path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1.5-1.5" />
  </svg>
);

// The circular "×" on an attachment preview.
export const RemoveIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

// Platform chip on a video attachment card.
export const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M21.6 7.2a2.7 2.7 0 0 0-1.9-1.9C18 5 12 5 12 5s-6 0-7.7.3A2.7 2.7 0 0 0 2.4 7.2 28 28 0 0 0 2 12a28 28 0 0 0 .4 4.8 2.7 2.7 0 0 0 1.9 1.9C6 19 12 19 12 19s6 0 7.7-.3a2.7 2.7 0 0 0 1.9-1.9A28 28 0 0 0 22 12a28 28 0 0 0-.4-4.8zM10 15V9l5 3z" />
  </svg>
);

export const VimeoIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M22 7.4c-.1 2.1-1.6 5-4.4 8.6-2.9 3.8-5.4 5.7-7.4 5.7-1.3 0-2.3-1.1-3.2-3.4l-1.7-6.4c-.6-2.3-1.3-3.4-2-3.4-.2 0-.7.3-1.6.9L0 8.2c1-.9 2-1.8 3-2.7C4.4 4.3 5.4 3.7 6.1 3.6c1.7-.2 2.7 1 3.1 3.5.4 2.8.7 4.5.9 5.2.5 2.3 1.1 3.4 1.7 3.4.5 0 1.2-.7 2.1-2.2.9-1.5 1.4-2.6 1.5-3.4.1-1.3-.4-1.9-1.5-1.9-.5 0-1 .1-1.6.4 1-3.3 3-4.9 5.8-4.8 2.1.1 3.1 1.5 2.9 4.1z" />
  </svg>
);

// The play glyph: the circular button overlaid on a video thumbnail, and
// the fallback tile shown when there's no thumbnail image to display.
export const PlayIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M8 5v14l11-7z" />
  </svg>
);
